import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

export const listAllNewFeatures = () => async (dispatch) => {
    try {
        const { data } = await api.listAllNewFeatures();

        dispatch({
            type: Actions.LIST_NEW_FEATURES,
            payload: data
        })
    } catch (error) {
        console.log(error);
    }
}